import React from 'react';
// Modules
import {
  Badge, Box, Text, VStack,
} from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
// Utils
import { Promotion } from '../../utils/interfaces';
import routes from '../../utils/routes';

interface Props {
  promotion: Promotion;
}

const PromotionCard: React.FC<Props> = ({ promotion }) => {
  const firstImage = promotion.images[0] ?? '/images/logo-square-1024.png';

  return (
    <Link href={routes.promotionInfo.as(promotion.id)} passHref>
      <Box
        _hover={{ boxShadow: 'xl' }}
        as="a"
        borderColor="gray.200"
        borderRadius="md"
        borderWidth="1px"
        overflow="hidden"
        transition="all 200ms ease-in-out"
      >
        <Box borderBottomColor="gray.200" borderBottomWidth="1px" position="relative" pt="100%">
          <Image layout="fill" objectFit="cover" src={firstImage} />
          {promotion.inStoreOnly && (
            <Badge position="absolute" right="4" top="4">Hanya di Toko</Badge>
          )}
        </Box>
        <VStack alignItems="flex-start" px="4" py="2" spacing="1">
          <Text fontSize="lg" fontWeight="semibold" noOfLines={1}>
            {promotion.name}
          </Text>
          <Text>{`${promotion.points.toLocaleString()} poin`}</Text>
        </VStack>
      </Box>
    </Link>
  );
};

export default PromotionCard;
